import { render, staticRenderFns } from "./PlotArea.vue?vue&type=template&id=f70c0ee6&scoped=true"
import script from "./PlotArea.vue?vue&type=script&lang=js"
export * from "./PlotArea.vue?vue&type=script&lang=js"
import style0 from "./PlotArea.vue?vue&type=style&index=0&id=f70c0ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c0ee6",
  null
  
)

export default component.exports